// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__mNpD2","title":"card_title__3mGdj","inActive":"card_inActive__3_laD"};